import { OrderProductTaxDisclaimer } from '@/components/order/order-summary/OrderProductTaxDisclaimer';
import { formatOrderSummaryText } from '@/components/order/order-summary/OrderSummaryButton';
import { useCrossSell } from '@/hooks/patient/refill/useCrossSell';
import { Box, Button, Typography } from '@montugroup/design-system';

export interface OrderSummaryButtonProps {
  totalNumberOfProducts: number;
  onClick: () => void;
  amount?: string;
  disabled?: boolean;
}

export function OrderSummaryButton(props: OrderSummaryButtonProps) {
  const { totalNumberOfProducts, onClick, amount, disabled } = props;
  const { showCrossSellPage } = useCrossSell();
  const text = formatOrderSummaryText({
    totalNumberOfProducts,
    amount,
    isCrossSell: showCrossSellPage,
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Button variant="contained" onClick={onClick} disabled={disabled}>
        <Typography variant="body1" component="span" sx={{ fontWeight: 600 }}>
          {text}
        </Typography>
      </Button>
      <OrderProductTaxDisclaimer />
    </Box>
  );
}
